import {
  getProjectKeysRepository
  } from "../Infrastructure/Keys.repository";

export async function getProjectKeysLogic(id) {
    return getProjectKeysRepository(id);
  }